module.exports = __webpack_public_path__ + "assets/img/node_active.00fc467e.png";